import { AutoMap } from "@automapper/classes"
import { Temporal } from "@js-temporal/polyfill"
import { BaseDOM } from "./base.dom";

export class Consommable extends BaseDOM<Consommable> {

    @AutoMap()
    /** Really needed to delete consommable as it's only managed in the client */
    Id?: number;

    @AutoMap()
    Type: number = 0
    @AutoMap()
    NumeroLot: string = ''
    @AutoMap()
    Expiration?: Temporal.PlainDate

}